import { ProductCarouselWithHeader } from '@teko/teko-ecommerce';
import { parseJsonStringSafely } from '@teko/utils';
import { isServerless } from 'helpers';
import { useSearch } from 'hooks';
import { t } from 'i18n';
import React, { useMemo } from 'react';
import { RECENTLY_VIEWED_PRODUCTS_KEY } from '../../../../../constants';
import {
  ProductProps,
  RecentViewedProductsBlock,
} from './RecentViewedProductsBlock';

interface RecentViewedProductsProps {
  showProductCard?: boolean;
  excludedSkus?: Array<string>;
}

export const RecentViewedProducts: React.FC<RecentViewedProductsProps> = (
  props,
) => {
  const { showProductCard, excludedSkus } = props;
  const recentViewedProductsSkus = isServerless()
    ? parseJsonStringSafely<string[]>(
        localStorage.getItem(RECENTLY_VIEWED_PRODUCTS_KEY) || '[]',
        [],
      ) || []
    : [];

  const { result, isLoading } = useSearch(
    recentViewedProductsSkus.length
      ? {
          filter: {
            skus: recentViewedProductsSkus,
            excludedSkus: excludedSkus,
          },
          page: 1,
          pageSize: 50,
        }
      : {},
  );

  // sort by sku order in local storage
  function sortBySkuOrder<T extends { sku: string }>(products: T[]): T[] {
    const newProducts: T[] = [];
    recentViewedProductsSkus.forEach((sku: string) => {
      const productFoundBySku = products.find((item: T) => item.sku === sku);
      if (productFoundBySku) {
        newProducts.push(productFoundBySku);
      }
    });
    return newProducts;
  }

  const recentViewedProducts: ProductProps[] = useMemo(() => {
    const discoveryResultProducts = result.products || [];
    const products = discoveryResultProducts.length
      ? discoveryResultProducts.map((product) => ({
          sku: product.sku,
          price: product.price?.latestPrice?.toString() || '',
          imageUrl: product.imageUrl || '',
          discountPercent: product.price?.discountPercent || '',
          link: product.link as ProductProps['link'],
        }))
      : [];
    return products.length ? sortBySkuOrder(products) : [];
  }, [result.products]);

  if (!recentViewedProducts.length && !isLoading) {
    return null;
  }

  return recentViewedProducts.length > 0 ? (
    showProductCard ? (
      <ProductCarouselWithHeader
        header={{
          title: t('Sản phẩm vừa xem'),
          style: { paddingLeft: '8px' },
        }}
        products={
          result.products?.length ? sortBySkuOrder(result.products) : []
        }
        style={{ backgroundColor: 'white' }}
      />
    ) : (
      <RecentViewedProductsBlock products={recentViewedProducts} />
    )
  ) : null;
};
